import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import type { Theme } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  margin-top: 48px;
  margin-bottom: -48px;
  min-height: 404px;


  @media (${breakpoint.mdMin}) {
    margin: 48px -24px 0px;
  }

  @media (${breakpoint.xlMin}) {
    margin: 48px -48px -48px -48px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1;
`;
